import {MxSelector} from '@aviary/store/store.types';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {HttpLoadingState} from './http-loading.state';
import {HTTP_LOADING_FEATURE_KEY} from './http-loading.types';

export namespace HttpLoadingSelectors {
  export const entireState: MxSelector<HttpLoadingState> = createFeatureSelector(HTTP_LOADING_FEATURE_KEY);

  export const activeRequestCount: MxSelector<number> = createSelector(
    entireState,
    state => state.activeRequestCount ?? 0
  );

  export const loading: MxSelector<boolean> = createSelector(
    activeRequestCount,
    count => count > 0
  );
}
